/* eslint-disable react-hooks/rules-of-hooks */
import MuiButton from "@mui/material/Button";
import type { ButtonProps as MuiButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormikContext } from "formik";
import type { FormikContextType } from "formik";
import type { SystemStyleObject, Theme } from "@mui/system";

type FormValues = Record<string, unknown>;
type FormikState = FormikContextType<FormValues> | null;

export interface ButtonProps extends Omit<MuiButtonProps, "disabled"> {
  loading?: boolean;
  disabled?: boolean | ((input: { formik: FormikState }) => boolean);
}

export function Button({
  id,
  name,
  children,
  type,
  color,
  variant,
  loading,
  startIcon,
  endIcon,
  disabled,
  onClick,
  onSubmit,
  sx,
}: ButtonProps) {
  let formik: FormikState = null;

  if (type === "submit") {
    formik = useFormikContext<FormValues>();
  }

  return (
    <MuiButton
      id={id}
      name={name}
      variant={variant}
      type={type}
      color={color}
      disabled={typeof disabled === "function" ? disabled({ formik }) : disabled || loading}
      startIcon={loading ? <CircularProgress size="1rem" /> : startIcon}
      endIcon={endIcon}
      onClick={onClick}
      onSubmit={onSubmit}
      sx={{ ...(sx as SystemStyleObject<Theme>) }}
    >
      {children}
    </MuiButton>
  );
}
